import _ from 'lodash';
import debounceAsync from 'debounce-async';

import {setHCListError} from '../../../actions';
import Utils from '../../../../../lib/utils';
import Api from '../../../../../lib/api';

/**
 * Data structure used to cache the value and error to avoid 
 * executing the function multiple times.
 * @type {{ value: string, error: string }}
 */
export const cache = {
  value: null, 
  error: null
};

/**
 * Utility to clear the cached value and error. 
 * Currently it is only be used on testing.
 * When testing these values things might get a little bit complicated, 
 * so it'd be better to clean them too on each test case.
 */
export const clearCache = () => {
  cache.value = null;
  cache.error = null;
};

export const asyncValidate = async (values, dispatch, props) => {
  if (values.tab === 'choose') {
    return {};
  }
  
  if (!values.email) {
    return {};
  }

  if (cache.value === values.email && !cache.error) {
    return {};
  }

  if (cache.value === values.email && cache.error) {
    throw {email: cache.error};
  }

  const local = props.local.strings.hiringClients;
  cache.value = values.email;

  try {
    const endpoint = `users/check-email?address=${values.email}`;
    const response = await Api.get(endpoint);

    if (_.get(response, 'data.data.emailExists')) {
      const message = local.addHCModal.contactTab.emailAlreadyTaken;
      cache.error = message;
      throw cache.error;
    }
  } catch (error) {
    if (cache.error) {
      throw {email: cache.error};
    } else if (_.get(error, 'response.data')) {
      dispatch(setHCListError(Utils.getErrorMessage(
        error.response.data, 
        local.actions
      )));
    } else {
      dispatch(setHCListError(local.actions.errorDefault));
    }
  }
  
  cache.error = null;

  return {};
};

export default debounceAsync(asyncValidate, 300);